import { useCallback } from 'react';
import { NavigationNode } from '~/lib/data-contract';
import { useGtm } from '~/shared/utils';

export const useTrackMenuClick = () => {
    const { trackMenuClick } = useGtm();
    const track = useCallback(
        (clickedLink: HTMLAnchorElement, categoryNode?: NavigationNode) => {
            const levels = [clickedLink.text];
            if (categoryNode) {
                levels.unshift(categoryNode.link?.text || '');
            }
            const [firstLevel, secondLevel] = levels;
            trackMenuClick(firstLevel, secondLevel);
        },
        [trackMenuClick]
    );
    return { track };
};
